var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
var AssetNameDropdown = function (_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, _b = _a.variant, variant = _b === void 0 ? 'outlined' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var _e = __read(useState(null), 2), anchorEl = _e[0], setAnchorEl = _e[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleSelect = function (selectedValue) {
        onChange(selectedValue);
        handleClose();
    };
    var selectedOption = options.find(function (opt) { return opt.id === value; });
    // Size mapping
    var sizeMap = {
        small: { height: 30, padding: '0px 8px', fontSize: 13 },
        medium: { height: 36, padding: '0px 12px', fontSize: 14 },
        large: { height: 48, padding: '0px 16px', fontSize: 15 }
    };
    var sizeStyles = sizeMap[size];
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: variant, color: 'inherit', size: size, onClick: handleClick, disabled: disabled, startIcon: _jsx(Icon, { icon: 'solar:replace-bold', width: 18, height: 18 }), endIcon: _jsx(Icon, { icon: 'eva:arrow-ios-downward-fill', width: 18, height: 18 }), sx: {
                    height: sizeStyles.height,
                    padding: sizeStyles.padding,
                    fontSize: sizeStyles.fontSize,
                    fontWeight: 700,
                    borderRadius: '8px',
                    borderColor: variant === 'outlined' ? 'rgba(145, 158, 171, 0.32)' : undefined
                }, children: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) || 'Asset name' }), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                }, children: options.map(function (option) { return (_jsx(MenuItem, { onClick: function () { return handleSelect(option.id); }, children: option.name }, option.id)); }) })] }));
};
export default AssetNameDropdown;
